import React, { useContext } from "react";
import { PciDashboardSummaryType } from "@app/projects/network-assessment/pci-dashboard/shared";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { ClaimsActivityDashboardContext } from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityDashboardContext";
import ClaimsActivityProvidersTile from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityProvidersTile";
import ClaimsActivityTopGhostProviderTile from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityTopGhostProviderTile";

export const ClaimsActivityDashboardDefaultView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsActivityContext = useContext(ClaimsActivityDashboardContext);

  return (
    <React.Fragment>
      <div className="row">
        <ClaimsActivityProvidersTile
          data={claimsActivityContext.networkProvidersSummaries}
          loading={claimsActivityContext.networkProvidersSummariesLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkTypeEnum.Network}
        />
        <ClaimsActivityProvidersTile
          data={claimsActivityContext.prospectProvidersSummaries}
          loading={claimsActivityContext.prospectProvidersSummariesLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkTypeEnum.Prospect}
        />
        <ClaimsActivityProvidersTile
          data={claimsActivityContext.marketProvidersSummaries}
          loading={claimsActivityContext.marketProvidersSummariesLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkTypeEnum.Market}
        />
      </div>
      <div className="row">
        <ClaimsActivityTopGhostProviderTile
          getTopGhostWidgetData={claimsActivityContext.getTopGhostWidgetData}
          loading={claimsActivityContext.topGhostProviderCountiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          topGhostProvidersModel={claimsActivityContext.topGhostProviderCountiesModel}
          summaryType={PciDashboardSummaryType.County}
        />
        <ClaimsActivityTopGhostProviderTile
          getTopGhostWidgetData={claimsActivityContext.getTopGhostWidgetData}
          loading={claimsActivityContext.topGhostProviderSpecialtiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          summaryType={PciDashboardSummaryType.Specialty}
          topGhostProvidersModel={claimsActivityContext.topGhostProviderSpecialtiesModel}
        />
      </div>
    </React.Fragment>
  );
}

export default ClaimsActivityDashboardDefaultView;
